
export const helpText = {
    pastureGrowth: "The estimated pasture growth required to meet the remaining energy needs of the animals on this source, accounting for the estimated energy already provided by crops and supplements",
    pastureIntake: "The estimated pasture intake consumed from this source, accounting for estimated pasture growth and utilisation rate"
}
